'use client';

import { SessionProvider } from 'next-auth/react';
import { UnsavedChangesProvider } from './components/unsaved-changes-context';

export default function Providers({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SessionProvider>
      <UnsavedChangesProvider>
        {children}
      </UnsavedChangesProvider>
    </SessionProvider>
  );
}